import { clearChatPersist } from '@/features/chat/chatPersist'
import { isChatApiConfigured } from '@/config/api/env'
import { useActiveProjectState } from './useActiveProjectState'
import { useChatThreadSlices } from './useChatThreadSlices'
import { useChatUiSlices } from './useChatUiSlices'

clearChatPersist()

/** In-memory chat shell slices; threads/messages hydrate via `useBackendThreadSync`. */
export function useChatPersistedSlices() {
  const persisted = null
  return {
    ...useChatUiSlices(persisted),
    ...useChatThreadSlices(persisted),
    ...useActiveProjectState(persisted),
    chatApiConfigured: isChatApiConfigured(),
  }
}
